import { AccordionProps } from '@mui/material';
import React from 'react';
import { useWizardSection } from '../hooks/useWizardSection';
import { StyledSection, StyledSectionOld } from './styles';
import { useIsNewSubway } from '../hooks/useIsNewSubway';

export const Section = ({
  sectionKey,
  children,
  sectionName: _,
  ...props
}: {
  sectionKey: string;
  sectionName: string;
  children: React.ReactNode;
} & AccordionProps) => {
  const isNewSubway = useIsNewSubway();
  const { active, toggleSection } = useWizardSection({
    key: sectionKey,
  });

  const SectionWrapper = isNewSubway ? StyledSection : StyledSectionOld;

  return (
    <SectionWrapper
      {...props}
      slotProps={{
        transition: {
          unmountOnExit: true,
          mountOnEnter: false,
        },
      }}
      expanded={active}
      elevation={3}
      onChange={() => toggleSection(sectionKey)}
    >
      {children}
    </SectionWrapper>
  );
};
